import { createClaudeFamilyCliDefinition } from "./factory.js";

export const claudeKimiCli = createClaudeFamilyCliDefinition({
  id: "claude-kimi",
  label: "Kimi (Claude Code)",
});
